import type { ReactNode } from 'react';

export function Dialogue({
  speaker,
  children,
  style,
}: {
  speaker: string;
  children: ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <div className="dialogue" style={style}>
      <span className="speaker">{speaker}</span>
      {children}
      <span className="arrow">▼</span>
    </div>
  );
}
